import React from 'react';
import { useOptimizedImages } from 'common/hooks/use-optimized-images';
import { ImagePlaceholder, ImageFallback } from '@navi-toolbox/ui-components';
import { image } from './styles';
import { useTranslation } from 'react-i18next';

type Props = {
  alt: string;
  src: string;
};

const size = 160;

export function Image({ alt, src }: Props) {
  const { t } = useTranslation();
  const optimized = useOptimizedImages(
    src,
    {
      size: { w: `${size}` },
    },
    {
      c: 'pad',
      b: 'white',
    },
  );

  return (
    <ImagePlaceholder
      className={image}
      src={optimized.size.x || ''}
      alt={alt}
      fallback={<ImageFallback alt={t('ui.image.alt')} className={image} width={size} height={size} />}
    />
  );
}
